/**
 * GSB AI Assistant Core Package
 * 
 * This package provides AI chat capabilities for the GSB platform,
 * enabling integration with various LLM providers through a unified API.
 * 
 * Key components:
 * - Entity interfaces for AI chat, messages, and LLM configuration
 * - AI Chat Service for communicating with the backend
 * 
 * @module gsb-ai-assistant
 */

// Export entity interfaces
export * from './interfaces/entity-interfaces';

// Export AI services
export * from './services/gsb-ai-chat.service';

/**
 * Library ID for the GSB AI Chat Service
 * This ID is used to identify the service in the GSB platform
 */
export const GSB_AI_CHAT_SERVICE_ID = '8562037a-8f11-4eae-ba97-6b7ccd852e57'; 